// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--0e205";
export var list = "index-module--list--9fcf1";